import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client } from '@app/models/client.model';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({
    providedIn: 'root',
})
export class PosApiService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly configService: ConfigService
    ) {}

    private get headers(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            secret_key: this.configService.config.posApiSecretKey,
        });
    }

    public getFromUserAccount(onlineId: string, customerId: string, emailId: string, siteId: string): Observable<any> {
        const url = `${this.configService.config.posApiUrl}/Client/GetFromUserAccount`;
        const body = {
            OnlineAccountGuid: onlineId,
            CustomerId: +customerId,
            EmailId: emailId,
            SiteId: siteId,
        };
        return this.httpClient.post(url, body, { headers: this.headers });
    }

    public associateUserAccount(customerId: string, onlineId: string, client: Client): Observable<any> {
        const url = `${this.configService.config.posApiUrl}/Client/AssociateUserAccount`;
        const OptInStatus = {
            OptedIn: 2,
            OptedOut: 3,
        } as const;
        const body = {
            CustomerId: +customerId,
            Client: {
                OnlineID: onlineId,
                FirstName: client.firstName,
                LastName: client.lastName,
                CellPhone: client.phoneNumber,
                Email: client.email,
                SendMarketingEmails: client.enableEmailMarketing,
                OptInStatus: client.enableTextMarketing ? OptInStatus.OptedIn : OptInStatus.OptedOut,
                SendAppointmentNotificationsSms: client.enableTextNotifications,
                Address1: client.address1,
                Address2: client.address2,
                City: client.city,
                State: client.state,
                PostalCode: client.zipCode,
            },
        };
        return this.httpClient.post(url, body, { headers: this.headers });
    }

    public getAppointmentByGuid(daysmartAccountID: string, rescheduleGuid: string): Observable<any> {
        const cid = parseInt(daysmartAccountID.split('-')[1]);
        const url = `${this.configService.config.posApiUrl}/DaysmartBooking/GetAppointment`;
        const body = {
            customerID: cid,
            guid: rescheduleGuid,
        };
        return this.httpClient.post<any>(url, body, { headers: this.headers });
    }

    public updateClientOnlineId(emailId: string, onlineId: string, customerId: string, siteId: string): Observable<any> {
        const url = `${this.configService.config.posApiUrl}/Client/UpdateOnlineId`;
        const body = {
            EmailId: emailId,
            OnlineId: onlineId,
            CustomerId: +customerId,
            SiteId: siteId,
        };
        return this.httpClient.post<any>(url, body, { headers: this.headers });
    }
}
